import React, { useCallback, useEffect } from "react";
import { useLocation } from "@reach/router";
import { useTranslation } from "react-i18next";
import { ALL_LANGUAGES } from "@src/i18next";

const formatLang = (lang: string) => {
  if (!lang) return lang;

  const [p1, p2] = lang.split("-");

  if (!p2) return p1;

  return `${p1}-${p2.toUpperCase()}`;
};

const isValidLanguage = (lang: string) => {
  return (
    ALL_LANGUAGES.includes(lang) ||
    ALL_LANGUAGES.includes(lang.toLowerCase()) ||
    ALL_LANGUAGES.includes(lang.toUpperCase())
  );
};

const LanguageDetector = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  const loadResources = useCallback(() => {
    const pathSegments = location.pathname.split("/");
    const langFromPath = formatLang(pathSegments[1]);

    if (langFromPath && isValidLanguage(langFromPath) && i18n.language !== langFromPath) {
      window.location.reload();
    }
  }, [i18n, location.pathname]);

  useEffect(() => loadResources(), [loadResources]);

  return null;
};

export default LanguageDetector;
